import { NgModule } from "@angular/core";
import { GSTCComponent } from "./angular-gantt-schedule-timeline-calendar.component";

@NgModule({
  declarations: [GSTCComponent],
  imports: [],
  exports: [GSTCComponent]
})
export class AngularGanttScheduleTimelineCalendarModule {}
